<template>
  <p-content-section>
    <template #header>
      <div class="user-header">
        <p-badge v-if="isBadgeVisible"
                 class="user-header__badge"
                 content="!"
                 variant="warn"/>
        <p-heading icon="profile" class="font-bold">{{ name }}</p-heading>
      </div>
    </template>
    <template #content>
      <div>
        <div class="cv__profile-row">
          <div class="cv__user-image">
            <p-tooltip position="bottom"
                       span-id="toottip-image"
                       text="Stuur je foto naar de vestiging waar jij aangesloten bent en zij voegen hem toe aan je profiel">
              <p-user-image :path="profilePicture?.path" />
            </p-tooltip>
          </div>
          <div class="cv__information-column">
            <p-tooltip :disabled="experience !== 0"
                       position="bottom"
                       span-id="tooltip-experience"
                       text="Nog niet genoeg werkervaring toegevoegd">
              <p-information-circle :number="experience"
                                    sub-text="Jaren ervaring in de zorg"
                                    type="filled"/>
            </p-tooltip>
          </div>
          <div v-if="experience" class="cv__experience--mobile experience">
            <h2 class="experience__number">
              {{ experience }}
            </h2>
            <p class="experience__text">
              {{ `${experience > 1 ? 'Jaren' : 'Jaar'}` }} ervaring in de zorg
            </p>
          </div>
        </div>
      </div>
    </template>
  </p-content-section>
</template>

<script lang="ts" setup>
defineProps<{
  profilePicture: { name: string; path: string } | null;
  name: string;
  experience: number | undefined;
  isBadgeVisible: boolean
}>();
</script>

<style lang="scss" scoped>
:deep(.content-section) {
  z-index: 1;
}
.user-header {
  position: relative;
  &__badge {
    position: absolute;
    top: -5px;
    left: 15px;
  }
}

.cv {
  &__profile-row {
    display: flex;
    flex-direction: row;
    gap: 48px;
    margin-bottom: 58px;
    position: relative;

    @media screen and (max-width: 600px) {
      flex-wrap: wrap;
      gap: 0;
      margin-bottom: 0;
      flex-direction: column;
    }
  }
  &__information-column {
    width: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;

    @media screen and (max-width: 600px) {
      display: none;
    }

    :deep(.information-circle__subtext) {
      position: absolute;
      width: 100%;

      @media screen and (max-width: 600px) {
        display: none;
      }
    }

    :deep(.information-circle) {
      margin-bottom: 0;
    }
  }
  &__experience {
    &--mobile {
      display: flex;
      flex-direction: row;
      margin-left: 8px;
      margin-top: -20px;
      width: 100%;
      @media screen and (min-width: 600px) {
        display: none;
      }
    }
  }
}

.experience {
  padding-top: 16px;
  &__text {
    align-self: center;
    margin-left: 10px;
    color: #152935;
    font-size: 16px;
  }
  &__number {
    color: #004d9d;
  }
}

:deep(.content-section__content) {
  overflow: visible;
}
</style>
